import PropTypes from 'prop-types';
import React from 'react';
import { Map } from 'immutable';

import { cardColorScheme } from '../../../styles/vars';

import TextBlock from '../../TextBlock';

import Wrapper from './Wrapper';
import QuoteWrapper from './QuoteWrapper';
import QuoteImage from './QuoteImage';
import QuoteText from './QuoteText';
import QuoteAuthor from './QuoteAuthor';
import CopyrightWrapper from './CopyrightWrapper';

export default class Quote extends React.PureComponent {
  static propTypes = {
    block: PropTypes.instanceOf(Map).isRequired,
    colorScheme: PropTypes.oneOf(Object.keys(cardColorScheme)),
    disableBold: PropTypes.bool,

    onChangeBlockField: PropTypes.func,
    onDropFile: PropTypes.func,
    onRemoveMedia: PropTypes.func,
  };

  UNSAFE_componentWillMount() {
    if (this.props.block.get('image')) {
      this.props.onChangeBlockField(true, '_withImage');
    }
  }

  handleChangeText = value => this.props.onChangeBlockField(value, 'content');

  handleChangeCopyright = value => this.props.onChangeBlockField(value, 'copyright');

  handleChangeAuthor = value => this.props.onChangeBlockField(value, 'cite');

  render() {
    const {
      block,
      colorScheme,
    } = this.props;

    const image = block.get('image');
    const withImage = block.get('_withImage');

    return (
      <Wrapper
        withImage={withImage}
        colorScheme={colorScheme}
      >
        {
          withImage && (
            <QuoteImage
              src={image && image.get('path')}
              colorScheme={colorScheme}
              onDropFile={this.props.onDropFile}
              onRemoveImage={this.props.onRemoveMedia}
            />
          )
        }
        <QuoteWrapper>
          <QuoteText>
            <TextBlock
              block={block}
              fieldName="content"
              placeholder="&quot;Добавьте цитату&quot;"
              disableBold={this.props.disableBold}
              autoFocus
              onChange={this.handleChangeText}
            />
          </QuoteText>
          <QuoteAuthor
            className="quoteAuthor"
            colorScheme={colorScheme}
          >
            <TextBlock
              block={block}
              fieldName="cite"
              placeholder="Автор высказывания"
              disableBold={this.props.disableBold}
              onChange={this.handleChangeAuthor}
            />
          </QuoteAuthor>
        </QuoteWrapper>
        {
          withImage && (
            <CopyrightWrapper>
              <TextBlock
                block={block}
                fieldName="copyright"
                placeholder="Добавьте копирайт"
                onChange={this.handleChangeCopyright}
              />
            </CopyrightWrapper>
          )
        }
      </Wrapper>
    );
  }
}
